import React, {useState} from 'react'
import styled from 'styled-components'
import ReactTelInput from 'react-telephone-input'
import './index.css'

const Label = styled.div`
	font-weight: 700;
	font-size: 13.5px;
	line-height: 1;
	margin-bottom: 5px;
`

const Container = styled.div`
	width: 50%;
	box-sizing: border-box;
	position: relative;
	margin-bottom: 30px;

	&:before {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.42);
	}

	:hover {
		&:before {
			border-bottom: 2px solid #4a4a4a;
		}
	}

	> .phoneInput {
		${props => props.invalid && `
			+ div {
				border-bottom: 2px solid #f44336;
				transform: scaleX(1);
			}
		`}

		${props => !props.invalid && `
			:focus {
				+ div {
					transform: scaleX(1);
				}
			}
		`}
	}
`

const Phone = ({label, config, defaultValue, fieldId, readonly, invalid, handleChange}) => {
	const [value, setValue] = useState(defaultValue)

	const onChange = (val, format) => {
		const number = convertToNumber(val)

		if (number === convertToNumber(format.dialCode)) {
			handleChange('c' + fieldId, '')
			setValue(number)
		} else {
			handleChange('c' + fieldId, `${number ? '+' : ''}` + number)
			setValue(number)
		}
    }

	const onBlur = (val, format) => {
		if (convertToNumber(val) === convertToNumber(format.dialCode)) {
			setValue('')
		}
	}

    const onFocus = (val, format) => {
		if (!value) {
        	setValue(format.dialCode)
		}
    }

	const convertToNumber = (value) => value.replace(/\D/g, '')
	
	return (
		<Container invalid={invalid} data-id={invalid ? fieldId : null}>
			<Label dangerouslySetInnerHTML={{__html: label}} />
			<ReactTelInput
				defaultCountry={config && config.country}
				flagsImagePath={null}
				value={value ? value.toString() : null}
				classNames={'phoneInput' + (value ? '' : ' novalue') + (readonly ? ' readonly' : '')}
				onFocus={!readonly && onFocus}
				onChange={onChange}
				onBlur={onBlur}
				inputProps={{
					readOnly: readonly
				}}
			/>
			<div />
		</Container>
	)
}

export default React.memo(Phone)